export interface Essay {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  date: string; // ISO
  dateDisplay: string;
  dateModified?: string; // ISO
  dateModifiedDisplay?: string;
  readingMinutes: number;
  summary?: string; // Short "In short:" opener for AI-search citation
  ogImage?: string; // Absolute URL to custom OG image; falls back to site default
}

export const essays: Essay[] = [
  {
    slug: "certainty-is-now-free",
    title: "Certainty is now free.",
    subtitle: "No amount of knowing will tell you what to do next.",
    author: "Kent H. Frazier",
    date: "2026-09-04",
    dateDisplay: "September 4, 2026",
    readingMinutes: 3,
    ogImage: "https://www.paradoxedge.com/og-certainty-is-now-free.png?v=3",
    summary:
      "The machine now delivers certainty on demand. The scarce resource becomes the human who can live into the questions when a plausible answer is one prompt away. This essay is about the edge, where knowing is not available and who we become when we stand there.",
  },
  {
    slug: "oversight-degrades-the-overseer",
    title: "Oversight Degrades the Overseer.",
    subtitle: "Approval is not oversight",
    author: "Kent H. Frazier",
    date: "2026-09-03",
    dateDisplay: "September 3, 2026",
    readingMinutes: 3,
    ogImage: "https://www.paradoxedge.com/og-oversight-degrades-the-overseer.png?v=2",
    summary:
      "The human in the loop is a safeguard, and that person is being worn down by the same use the safeguard depends on. The proposals on the table handle volume. They do not develop judgment.",
  },
  {
    slug: "tech-led-human-powered",
    title: "A tech-led, human-powered world?",
    subtitle: "A question about who leads, who powers, and who is accountable",
    author: "Kent H. Frazier",
    date: "2026-09-02",
    dateDisplay: "September 2, 2026",
    readingMinutes: 3,
    ogImage: "https://www.paradoxedge.com/og-tech-led-human-powered.png?v=2",
    summary:
      "The phrase ‘tech-led, human-powered world’ puts machines in charge and humans in service. A better story is human-led and tech-powered: wisdom, judgment, and accountability remain the work of human beings.",
  },
  {
    slug: "the-space-between",
    title: "The Space Between",
    subtitle: "What grows trust",
    author: "Kent H. Frazier",
    date: "2026-07-14",
    dateDisplay: "July 14, 2026",
    readingMinutes: 5,
    ogImage: "https://www.paradoxedge.com/og-the-space-between.png?v=1",
    summary:
      "Trust built on role, title, and delivery is brittle. It snaps under pressure. Trust built between two people who have actually met each other holds. This essay is about the space between: what Buber called the between, what grows there, and why it is the developmental ground of being fully human at work.",
  },
  {
    slug: "the-human-loop",
    title: "The Human Loop",
    subtitle:
      "What the token capital era gets right, what it cannot see, and the asset no one can extract",
    author: "Kent H. Frazier",
    date: "2026-06-10",
    dateDisplay: "June 10, 2026",
    dateModified: "2026-07-25",
    dateModifiedDisplay: "July 25, 2026",
    readingMinutes: 8,
    ogImage: "https://www.paradoxedge.com/og-the-human-loop.png?v=2",
    summary:
      "AI's 'token capital' loop compounds what your people already knew. But the scarce asset (human judgment, taste, and trust) needs its own loop. Organizations that thrive will run both: extraction alongside development.",
  },
];

export const getEssay = (slug: string) => essays.find((e) => e.slug === slug);